<label class="label" [class.is-error]="virhe">{{ 'tositteet.lisaa-tositteita.maksutapa-valinta.label' | translate | async }}<span class="req">*</span></label>

<div class="pay-toggles" [class.is-locked]="lukittu" role="radiogroup" [attr.aria-label]="'tositteet.lisaa-tositteita.maksutapa-valinta.valitse-maksutapa-aria' | translate | async">
  @for (v of maksutavatObservable | async; track v.id) {
    <button type="button" role="radio" [attr.aria-checked]="valittu === v.id" class="pay-toggle" [class.is-selected]="valittu === v.id" [disabled]="lukittu" (click)="valitseMaksutapa(v.id)" [attr.aria-label]="v.otsikko">
      <span class="pay-icon">
        <img [src]="v.kuva" [alt]="v.otsikko" />
      </span>
      <span class="pay-label">{{ v.otsikko }}</span>
    </button>
  }
</div>

@if (virhe) {
  <div class="hint error">
    <span class="material-symbols-outlined" aria-hidden="true">info</span>
    {{ virhe | translate | async }}
  </div>
}
